<template>
    <div class="container-fluid error-wrapper">
        <div class="row">
            <div class="col-md-12 hidden-sm hidden-xs no-float">
                <div class="error-part">
                    <div class="logo">
                        <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart">
                        <span v-else>{{ project }}</span>
                    </div>
                    <div class="title-wrap">
                        <h1 class="main-title">404 </h1>
                        <h2 class="main-sub-title">Houston, we have a problem.</h2>
                        <a href="/public" class="btn btn-primary">Go Home</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageNotFound",
    data: () => ({
        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
    }),
}
</script>

<style lang="scss" scoped>
    .error-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(144.89deg, #fff 2.83%, #3598dc 100%);
        z-index: 99999999;
        .error-part {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            .logo-smart {
                margin: 0;
            }
            .main-title {
                font-size: 70px;
            }
            .btn {
                margin-top: 20px;
            }
        }
    }
</style>
